const readUser = () => {
  try {
    return JSON.parse(localStorage.getItem('user') || '{}');
  } catch {
    return {};
  }
};

export const isPartnerOrAffilieUser = () => {
  const u = readUser();
  return (
    u.role === 'affilie' ||
    u.role === 'client' ||
    u.userType === 'partner' ||
    u.role === 'partenaire' ||
    u.role === 'partner'
  );
};

export const isAffilieUser = () => {
  const u = readUser();
  return u.role === 'affilie';
};

export const resolveConnectedPartnerId = () => {
  const u = readUser();
  // Affilié: use parent partner so reservations appear on the partenaire list
  const raw =
    u.role === 'affilie'
      ? u.id_partenaire_parent ?? u.partner_id ?? u.user_partner_id ?? u.id
      : u.user_partner_id ?? u.id_partenaire ?? u.id;
  if (raw == null || raw === '') return null;
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : null;
};

export const resolveConnectedAffilieId = () => {
  const u = readUser();
  if (u.role !== 'affilie' || u.id == null || u.id === '') return null;
  const n = Number(u.id);
  return Number.isFinite(n) && n > 0 ? n : null;
};

/**
 * IDs persistés en base (compte B2B, facturation). Complète le brouillon au submit.
 */
export function resolveTransferBillingIds(draft) {
  let billingClientId =
    draft?.billing_client_id != null && draft.billing_client_id !== ''
      ? Number(draft.billing_client_id)
      : null;
  let billingPartnerId =
    draft?.billing_partner_id != null && draft.billing_partner_id !== ''
      ? Number(draft.billing_partner_id)
      : null;

  if (isPartnerOrAffilieUser()) {
    const partnerId = resolveConnectedPartnerId();
    if (partnerId) {
      billingPartnerId = partnerId;
    }
  } else if (billingClientId && !billingPartnerId && draft?.billing_client_kind === 'morale') {
    billingPartnerId = billingClientId;
  }

  return {
    billing_client_id: Number.isFinite(billingClientId) ? billingClientId : null,
    billing_partner_id: Number.isFinite(billingPartnerId) ? billingPartnerId : null,
    id_affilie: resolveConnectedAffilieId(),
  };
}
